import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { IntlProvider } from 'react-intl';

import { carouselSettingShape } from '@bibliocommons/bc-prop-types';
import BaseCarousel from '@bibliocommons/carousel-base';
import ListCard from '@bibliocommons/deprecated-list-card';

import './ListCarousel.scss';

const ListCarousel = ({
  headingTag,
  carouselTitle,
  listItems,
  carouselSettings,
  cardProps,
  carouselTitleLink,
  onListImageClick,
  onListTitleClick
}) => {
  const titleData = { headingTag, carouselTitle, carouselTitleLink };
  const { containerName, ...settings } = carouselSettings;

  const handleListImageClick = list => {
    if (typeof onListImageClick === 'function') {
      onListImageClick(list, carouselTitle);
    }
  };

  const handleListTitleClick = list => {
    if (typeof onListTitleClick === 'function') {
      onListTitleClick(list, carouselTitle);
    }
  };

  const renderListCard = list => (
    <ListCard
      key={list.listId}
      handleImageClick={() => handleListImageClick(list)}
      handleTitleClick={() => handleListTitleClick(list)}
      {...list}
      {...cardProps}
    />
  );

  return (
    <div className="cp-list-carousel">
      <BaseCarousel.BaseCarousel {...settings} titleData={titleData}>
        {_.map(listItems, renderListCard)}
      </BaseCarousel.BaseCarousel>
    </div>
  );
};

ListCarousel.propTypes = {
  headingTag: PropTypes.string,
  cardProps: PropTypes.shape({
    cardHeadingTag: PropTypes.string,
    border: PropTypes.bool,
    imageIsDecorative: PropTypes.bool,
    imageAlt: PropTypes.string,
    rectangle: PropTypes.bool
  }),
  carouselTitle: PropTypes.string,
  carouselTitleLink: PropTypes.string,
  containerName: PropTypes.string,
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      listId: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string,
      description: PropTypes.string,
      imageSrc: PropTypes.string,
      creator: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })
    })
  ),
  carouselSettings: carouselSettingShape,
  onListImageClick: PropTypes.func,
  onListTitleClick: PropTypes.func
};
/**
 * ListCarousel.defaultProps
 * @type {Object}
 *
 * ANY CHANGES TO THESE DEFAULTS MUST
 * BE REPORTED TO THE WEB AND RAILS TEAMS
 */
ListCarousel.defaultProps = {
  listItems: [],
  headingTag: 'h1',
  cardProps: {
    cardHeadingTag: 'h2',
    border: true,
    imageIsDecorative: false,
    imageAlt: '',
    rectangle: true
  },
  carouselSettings: {
    buttonBackgroundColor: '#fff',
    breakpointSettings: {
      1000000: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 4,
        gutterSize: '20px',
        partiallyShowOffscreenItems: false
      },
      1280: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 4,
        gutterSize: '20px',
        partiallyShowOffscreenItems: false
      },
      991: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 3,
        gutterSize: '40px',
        partiallyShowOffscreenItems: false
      },
      767: {
        showDots: false,
        useTouchArrows: true,
        itemsPerPage: 2,
        gutterSize: '20px',
        partiallyShowOffscreenItems: true
      },
      576: {
        showDots: false,
        useTouchArrows: true,
        itemsPerPage: 1,
        gutterSize: '20px',
        partiallyShowOffscreenItems: true
      }
    }
  }
};

export default ListCarousel;

export const LocalizedListCarousel = ({ messages, locale, ...carouselProps }) => (
  <IntlProvider messages={messages} locale={locale} timeZone="UTC">
    <ListCarousel {...carouselProps} />
  </IntlProvider>
);

LocalizedListCarousel.propTypes = {
  messages: PropTypes.objectOf(PropTypes.string),
  locale: PropTypes.string
};

LocalizedListCarousel.defaultProps = {
  locale: 'en',
  messages: {}
};
